import type { ReactNode } from "react";

export interface Column<T> {
  key: string;
  header: string;
  width?: string | number;
  render: (row: T) => ReactNode;
}

interface Props<T> {
  rows: T[] | undefined;
  columns: Column<T>[];
  rowKey: (row: T) => string;
  loading?: boolean;
  emptyMessage?: string;
  onRowClick?: (row: T) => void;
}

export default function DataTable<T>({ rows, columns, rowKey, loading, emptyMessage, onRowClick }: Props<T>) {
  if (loading) {
    return <div className="bo-table-loading">Chargement…</div>;
  }
  if (!rows || rows.length === 0) {
    return <div className="bo-table-empty">{emptyMessage ?? "Aucun résultat."}</div>;
  }
  return (
    <div className="bo-table-wrap">
      <table className="bo-table">
        <thead>
          <tr>
            {columns.map((c) => (
              <th key={c.key} style={{ width: c.width }}>
                {c.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr
              key={rowKey(row)}
              onClick={onRowClick ? () => onRowClick(row) : undefined}
              className={onRowClick ? "is-clickable" : undefined}
            >
              {columns.map((c) => (
                <td key={c.key}>{c.render(row)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
